import { render, staticRenderFns } from "./BranchQue.vue?vue&type=template&id=ae2609c8&scoped=true&lang=pug"
import script from "./BranchQue.vue?vue&type=script&lang=js"
export * from "./BranchQue.vue?vue&type=script&lang=js"
import style0 from "./BranchQue.vue?vue&type=style&index=0&id=ae2609c8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2609c8",
  null
  
)

export default component.exports